import { makeStyles } from '@griffel/react';

export const useClassNames = makeStyles({
  container: {
    overflowY: 'hidden',
  },
});
